import { render, staticRenderFns } from "./view-detail-tab.vue?vue&type=template&id=d9b5f528&"
import script from "./view-detail-tab.vue?vue&type=script&lang=js&"
export * from "./view-detail-tab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports